import { useEffect } from 'react'

import { fetchAlternativeOffers } from 'actions/OfferActions'
import { useAppDispatch, useAppSelector } from 'hooks/reduxHooks'

function useAlternativeOffers(
  propertyId: string | undefined,
  type: 'le' | 'bedbank',
  options: { disabled?: boolean } = {},
): App.AlternativeOffers | undefined {
  const dispatch = useAppDispatch()

  const alternatives = useAppSelector(state =>
    propertyId ? state.offer.alternativeOffersForProperty[propertyId] : undefined,
  )

  const isFetchRequired = !!propertyId && !options.disabled && !alternatives
  useEffect(() => {
    if (isFetchRequired) {
      dispatch(fetchAlternativeOffers(propertyId, type))
    }
  }, [dispatch, isFetchRequired, propertyId, type])

  if (options.disabled) return undefined
  return alternatives
}

export default useAlternativeOffers
